import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% STATE %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  state: {
    locale: 'en',
    rtl: false
  },

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% MUTATIONS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  mutations: {
    setLocale: (state, payload) => {
      state.locale = payload
    },

    setRtl: (state, payload) => {
      state.rtl = payload
    }
  },

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% GETTERS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  getters: {
    getLocale: state => {
      return state.locale
    },

    getRtl: state => {
      return state.rtl
    }
  },

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% ACTIONS %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  actions: {
    setLocale: ({ commit }, payload) => {
      commit('setLocale', payload)
    },

    setRtl: ({ commit }, payload) => {
      commit('setRtl', payload)
    }
  }
})
